export const APP_NAME = {
  VPN99: 'vpn99',
  TRUST_VPN: 'trustvpn',
}

const config = (async () =>
  (await import(`./${process.env.VUE_APP__APP_NAME}/config.js`)).default)()

export default config
